module.exports = __webpack_public_path__ + "static/media/border-style-alt.d6064c45.svg";